import styled, { keyframes, css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: fit-content;
    padding: 0;
    margin: 36px 0 0 0;
    background-color: ${theme.v2.colors.neutral.highPure};
  `};
`;

export const CenterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
  justify-content: center;
  gap: 16px;
`;

export const Carousel = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    overflow: hidden;
    user-select: none;
    margin: 0;
    width: 100%;
    height: fit-content;
    gap: 28px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 20px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 10px;
    }
  `};
`;

const scrollXToLeft = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const scrollXToRight = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(50%);
  }
`;

export const Slider = styled.div`
  ${({ theme, showAgentBlock }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 40px;
    height: ${showAgentBlock ? '200px' : '215px'};
    will-change: transform;

    animation: ${({ $direction }) => ($direction === 'right'
    ? css`
            ${scrollXToRight} 200s linear infinite
          `
    : css`
            ${scrollXToLeft} 200s linear infinite
          `)};

    > * {
      flex-shrink: 0;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 10px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: ${showAgentBlock ? '150px' : '165px'};
      gap: 12px;
    }
  `};
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const AnimatedSlider = styled(Slider)`
  opacity: 0;
  transform: translateY(100px);
  transition: opacity 1s ease, transform 1s ease;

  &.visible {
    opacity: 1;
    animation: ${slideIn} 1s ease forwards;
  }

  &.start-scroll {
    animation: ${({ $direction }) => ($direction === 'right'
    ? css`
            ${scrollXToRight} 200s linear infinite
          `
    : css`
            ${scrollXToLeft} 200s linear infinite
          `)};
  }
`;

export const SliderImage = styled.img`
  ${({ theme, showAgentBlock }) => css`
    display: block;
    object-fit: contain;
    height: ${showAgentBlock ? '200px' : '215px'};
    width: auto;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: ${showAgentBlock ? '150px' : '165px'};
    }
  `};
`;
